import { render, staticRenderFns } from "./noticiaCard.vue?vue&type=template&id=bca7d1e2&scoped=true"
import script from "./noticiaCard.vue?vue&type=script&lang=js"
export * from "./noticiaCard.vue?vue&type=script&lang=js"
import style0 from "./noticiaCard.vue?vue&type=style&index=0&id=bca7d1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca7d1e2",
  null
  
)

export default component.exports